import React, { useState, useEffect } from "react";
import "./ActiveList.css";
import {
  serviceInclinicHourlyGraph,
  ServiceInclinicList,
  ServiceConsultationNotes,
  ServiceSummaryData,
} from "../Services/Service";
import { ChartIncludeColumn } from "./Chart/ChartInclude";
import { Link } from "react-router-dom";
import Table from "./DataTable/DataTable";
import { CustomLoader, formatDate_dMYHiP } from "../Services/CommonLibrary";
import { Modal, Button } from "react-bootstrap";
import { MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import { DateRangeComp } from "./DatePicker/CustomRangeDatePicker";
import HourlyGraph from "./Chart/hourlyGraph";
import format from "date-fns/format";
import $ from "jquery";
import { formatUkNumber } from "./Utils";
import CommonModal from "../WebPages/components/CommonModal";

const UserList = (props) => {
  const clickhandler = (name) => console.log("delete", name);
  const [serviceData, setServiceData] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [consultationData, setConsultationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startRange, setStartRange] = useState("");
  const [endRange, setEndRange] = useState("");
  const [loadingInclinic, setLoadingInclinic] = useState(false); // New state

  const [limit, setLimit] = useState(10);
  const [totalData, setTotalData] = useState("");

  const [showAttemptsModal, setShowAttemptsModal] = useState(false);
  const [attemptList, setAttemptList] = useState([]);


  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const [seriesGraph, setSeriesGraph] = useState({
    hourlyCategory: [],
    hourlySeries: [],
  });
  const houryCategorization = ["#007bff", "#28a745"];     //Accouint Created: '#007bff', 'Fully onboarded': '#28a745'

  useEffect(() => {
    fetchSummary();
    fetchHourlyGraph();
    fetchActiveList();
  }, [startRange]);

  const fetchActiveList = async () => {
    setLoadingInclinic(true); // Start inclinic list loader
    ServiceInclinicList(startRange, endRange).then((res) => {
      setServiceData(res.data.data);
      setLoading(false);
      setLoadingInclinic(false); // Stop inclinic list loader
    });
    // console.log("data14526", serviceData);
  };

  const fetchSummary = async () => {
    ServiceSummaryData(startRange, endRange).then((res) => {
      if (res.data.status == 1) {
        setSummaryData(res.data.data);
      } else {
        setSummaryData("");
      }
      setLoading(false);
    });
  };
  const fetchHourlyGraph = async () => {
    serviceInclinicHourlyGraph(startRange, endRange).then((res) => {
      setSeriesGraph((prevState) => ({
        ...prevState,
        hourlyCategory: res.data.data.category,
        hourlySeries: res.data.data.series,
      }));
      setLoading(false);
    });
    // console.log("data14526", seriesGraph);
  };
  const viewPopup = (callId) => {
    setConsultationData("");
    setShowModal(true);
    ServiceConsultationNotes(callId).then((res) => {
      setConsultationData(res.data.data);
      // setLoading(false);
    });
  };

  const getData = (data) => {
    let start = format(data[0].startDate, "yyyy-MM-dd");
    let end = format(data[0].endDate, "yyyy-MM-dd");
    // alert(dateRangeSelect)
    // fetchSummary(start,end);
    // fetchHourlyGraph(start,end);
    setStartRange(start);
    setEndRange(end);
  };

  const closeAttemptsModal = () => {
    setShowAttemptsModal(false);
    setAttemptList([]);
  };

  const viewAttempts = (row) => {
    setAttemptList(row.coachAttemptDetails || []); // store full attempts list
    setShowAttemptsModal(true);
  };

  const columns = [
    { 
      name: "#", 
      cell: (row, index) => index + 1, 
      sortable: false, 
      grow: 0 
    },
    {
      name: <div className="tdData text-wrap">Booking Date and time</div>,
      cell: (row) => <div className="text-wrap">{formatDate_dMYHiP(row.createdTime)}</div>,
      selector: (row) => row.createdTime,
      sortable: true,
    },
    {
      name: <div className="tdData text-wrap">Consultation Date and time</div>,
      cell: (row) => <div className="text-wrap">{formatDate_dMYHiP(row.dateScheduled)}</div>,
      selector: (row) => row.dateScheduled,
      sortable: true,
    },
    {
      name: <div className="tdData text-wrap">Patient Name</div>,
      cell: (row) => <div className="tdData text-wrap">{row.userFullName}</div>, 
      sortable: true,
    },
    {
      name: <div className="tdData text-wrap">NHS ID</div>,
      cell: (row) => <div className="tdData text-wrap">{row.nhsId}</div>,
      selector: (row) => row.nhsId,
      sortable: true,
    },
    {
      name: <div className="tdData text-wrap">Coach Name</div>,
      cell: (row) => <div className="text-wrap">{row.coachFullName}</div>,
      selector: (row) => row.coachFullName,
      sortable: true,
    },
    {
      name: <div className="tdData text-wrap">Division</div>,
      cell: (row) => <div className="text-wrap">{row.divisionName}</div>,
      selector: (row) => row.divisionName,
      sortable: true,
    },
    {
      name: <div className="tdData text-wrap">Practice Name</div>,
      cell: (row) => <div className="text-wrap">{row.practiceName}</div>,
      selector: (row) => row.practiceName,
      sortable: true,
    },
    {
      name: <div className="tdData text-wrap">Agent Name</div>,
      cell: (row) => <div className="text-wrap">{row.agentName}</div>,
      selector: (row) => row.agentName,
      sortable: true,
    },
    {
      name: <div className="tdData text-wrap">Consultation Status</div>,
      cell: (row) => <div className="text-wrap">{row.status}</div>,
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: <div className="tdData text-wrap">Coach Join Time</div>,
      cell: (row) => <div className="text-wrap">{formatDate_dMYHiP(row.callMadeOn)}</div>,
      selector: (row) => row.callMadeOn,
      sortable: true,
    },
    {
      name: <div className="tdData text-wrap">Patient Join Time</div>,
      cell: (row) => <div className="text-wrap">{formatDate_dMYHiP(row.patientJoinedOn)}</div>,
      selector: (row) => row.patientJoinedOn,
      sortable: true,
    },
    {
      name: <div className="tdData text-wrap">No of Attempts (Coach)</div>,
      cell: (row) => (
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => viewAttempts(row)}
        >
          {row.attempts}
        </button>
      ),
      selector: (row) => row.attempts,
      sortable: true,
    },
    {
      name: <div className="tdData text-wrap">Consultation Notes</div>,
      button: true,
      cell: (row) => {
        return row.callNotesDisplay == "true" ? (
          <button
            className="btn btn-secondary btn-sm btn-edit text-nowrap"
            onClick={(e) => viewPopup(row.callId)}
          >
            View
          </button>
        ) : null;
      },
    },
  ];
  
  const modalbody = "<span>HELLO BODY</span>";

  return (
    <section className="projects-section">
      <div className="row align-items-center">
        <div className="" style={{ display: "flex", justifyContent: "end", width: "100%" }}>
          <h3 className="title"> </h3>
          <div className="col-md-auto pe-1">
            <DateRangeComp
              typeofdate="blank"
              filterParam={{ smsStartFilter: startRange }}
              onClick={getData}
            />
          </div>
          <div className="col-md-auto ps-0">
            <button
              type="button"
              className="btn btn-success btn-sm"
              onClick={(e) => {
                setStartRange("");
                setEndRange("");
              }}
            >
              Clear
            </button>
          </div>
        </div>
        <div className="table-responsive mt-2">
          <MDBTable align="middle">
            <MDBTableHead>
              <tr className="table-head">
                <th scope="col">Practice Name</th>
                <th scope="col">Completed</th>
                <th scope="col">
                  Incomplete <br />
                  (Patient didn't join)
                </th>
                <th scope="col">
                  Missed <br />
                  (Coach didn't join)
                </th>
                <th scope="col">Scheduled</th>
                <th scope="col">Re-Scheduled</th>
                <th scope="col">Cancelled</th>
                <th scope="col">Grand Total</th>
              </tr>
            </MDBTableHead>
            {summaryData.length > 0 ? (
              <MDBTableBody>
                {summaryData.map((data, i) => (
                  <tr key={i}>
                    <td>{data.practiceName}</td>
                    <td>{formatUkNumber(data.complete)}</td>
                    <td>{formatUkNumber(data.incomplete)}</td>
                    <td>{formatUkNumber(data.missed)}</td>
                    <td>{formatUkNumber(data.scheduled)}</td>
                    <td>{formatUkNumber(data.rescheduled)}</td>
                    <td>{formatUkNumber(data.cancelled)}</td>
                    <td>
                      {formatUkNumber(Number(data.complete) +
                        Number(data.incomplete) +
                        Number(data.missed) +
                        Number(data.scheduled) +
                        Number(data.rescheduled) +
                        Number(data.cancelled))}{" "}
                    </td>
                  </tr>
                ))}
              </MDBTableBody>
            ) : (
              <MDBTableBody>
                <tr>
                  <td colSpan={5}>No Records Found</td>
                </tr>
              </MDBTableBody>
            )}
          </MDBTable>
          <div className="col-md-12 mt-5">
            <h1 className="title">Hourly Data</h1>
            {/* <HourlyGraph /> */}
            <ChartIncludeColumn
              series={seriesGraph.hourlySeries}
              category={seriesGraph.hourlyCategory}
              chartType="column"
              color={houryCategorization}
            />
          </div>
          <hr className="line" />
        </div>
      </div>
      <div className="row">
        <div className="FL">
          {/* <div className="row mb-3 align-items-center displayFlex">
                        <div className="col-md-10">
                            <h1 className="title">Inclinic</h1>
                            <h3 className="title">Total - {totalData}</h3>
                        </div>
                    </div> */}
          {/* <div className='table-responsive' id="inclinicList">
                        <Table data={serviceData} column={columns} title="Inclinic" click={clickhandler}  exportCSV='true' csvName='Inclinic'/>
                    </div> */}
          {loadingInclinic ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "150px" }}
            >
              Loading...
            </div>
          ) : (
            <Table
              data={serviceData}
              column={columns}
              title="Inclinic"
              click={clickhandler}
              exportCSV="true"
              csvName="Inclinic"
            />
          )}
        </div>
      </div>
      {loading ? <CustomLoader /> : null}

      {showModal ? (
        <>
          <Modal
            dialogClassName="modal-xl"
            show={showModal}
            onHide={handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Consultation Notes</Modal.Title>
            </Modal.Header>
            <Modal.Body
              dangerouslySetInnerHTML={{ __html: consultationData }}
            ></Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      ) : null}

      <CommonModal
        show={showAttemptsModal}
        onClose={closeAttemptsModal}
        title="Coach Call Attempts"
        size="lg"
      >
      {attemptList.length === 0 ? (
        <p>No attempts found</p>
      ) : (
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Attempt Time</th>
            </tr>
          </thead>
          <tbody>
            {attemptList.map((item, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{formatDate_dMYHiP(item.attemptTime)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </CommonModal>

    </section>
  );
};
export default UserList;
